import FloatingActionButton from '@stories/Components/Buttons/FloatingActionButton/FloatingActionButton';
import * as React from 'react';
import { useModal } from '../Context/Context';
const Close = () => {
    const modal = useModal();
    return (React.createElement(FloatingActionButton, { mode: "button", type: "button", onClick: modal.onClose }, modal.closeLabel));
};
export default Close;
